export default __webpack_public_path__ + "static/media/logo_everis.b5d142e9.png";